var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOtwindow = function SvgOtwindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.667H1.333V1.333H5V0H1.333A1.333 1.333 0 0 0 0 1.333v9.334A1.333 1.333 0 0 0 1.333 12h9.334C11.4 12 12 11.4 12 10.667V7h-1.333v3.667ZM7.333 0v1.333h2.394L3.173 7.887l.94.94 6.554-6.554v2.394H12V0H7.333Z",
    fill: "#333"
  })));
};
export default SvgOtwindow;